import { render, staticRenderFns } from "./ChristmasTree.vue?vue&type=template&id=fc4960de&lang=pug"
import script from "./ChristmasTree.vue?vue&type=script&lang=js"
export * from "./ChristmasTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports